import DataExportBusinessDataTemplate from '../../components/5templates/DataExportBusinessDataTemplate'
import {useState} from 'react'
import {downloadCsvData, getRequiredExportId} from '../../services/util/miscellaneousService'
import ApiService from '../../common/ApiCalls'

const DataExportBusinessData = () => {
    const [dataSet, setDataSet] = useState('')
    const onDataSetChange = (newValue) => {
        setClient(null)
        setServiceTypeId('')
        setService(null)
        setDataSet(newValue)
        setContactTypeName('')
        setContact(null)
    }

    const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = useState(false)

    const [client, setClient] = useState(null)

    const [serviceTypeId, setServiceTypeId] = useState('')
    const onServiceTypeChange = (newValue) => {
        setServiceTypeId(newValue)
        setService(null)
    }

    const [service, setService] = useState(null)
    const onServiceChange = (newValue) => {
        setService(newValue)
    }

    const [contactTypeName, setContactTypeName] = useState('')
    const onContactTypeChange = (newValue) => {
        setContactTypeName(newValue)
        setContact(null)
    }

    const [contact, setContact] = useState(null)
    const onContactChange = (newValue) => {
        setContact(newValue)
    }

    const downloadAllLocationsByClient = async () => {
        await downloadCsvData(()=>ApiService().getAllLocationsCsvDataForClient(
            getRequiredExportId(client, 'account_id', 'id')
        ),
            setIsErrorSnackbarOpen, 'locations_by_client')
    }

    const downloadAllLocationsByService = async () => {
        await downloadCsvData(()=>ApiService().getAllLocationsCsvDataForService(
            getRequiredExportId(service, 'id', 'service_id')
        ),
            setIsErrorSnackbarOpen, 'locations_by_service')
    }

    const downloadAllLocationsByContact = async () => {
        await downloadCsvData(()=>ApiService().getAllLocationsCsvDataForContact(
            getRequiredExportId(contact, 'id', 'contact_id')
        ),
            setIsErrorSnackbarOpen, 'locations_by_contact')
    }

    const downloadAllTrainingRecordsByContact = async () => {
        await downloadCsvData(()=>ApiService().getAllTrainingRecordsForContact(
            getRequiredExportId(contact, 'id', 'contact_id')
        ),
            setIsErrorSnackbarOpen, 'training_records_by_contact')
    }

    const downloadAllInfoByClient = async () => {
        await downloadCsvData(()=>ApiService().getClientDetailsCsvData(
            getRequiredExportId(client, 'account_id', 'id')
        ),
            setIsErrorSnackbarOpen, 'client_details')
    }

    const handleExportButton = async () => {
        switch(dataSet){
            case 'All locations of a Client':
                await downloadAllLocationsByClient()
                break
            case 'All locations with this Service':
                await downloadAllLocationsByService()
                break
            case 'All locations assigned to a Contact':
                await downloadAllLocationsByContact()
                break
            case 'All training records for a Contact':
                await downloadAllTrainingRecordsByContact()
                break
            case 'All info for a Client':
                await downloadAllInfoByClient()
                break
            default:
                console.log('There is an error')
        }
    }

    const disabled = (step) => {
        switch (step) {
            case 0:
                return dataSet === ''
            case 1:
                return !client && !service && !contact
            default:
                return false
        }
    }

    return (
        <DataExportBusinessDataTemplate dataSet={dataSet} onDataSetChange={onDataSetChange} disabled={disabled}
                                        client={client} setClient={setClient} serviceTypeId={serviceTypeId}
                                        onServiceTypeChange={onServiceTypeChange} service={service} onServiceChange={onServiceChange}
                                        contactTypeName={contactTypeName} onContactTypeChange={onContactTypeChange}
                                        contact={contact} onContactChange={onContactChange} handleExportButton={handleExportButton}
                                        isErrorSnackbarOpen={isErrorSnackbarOpen} setIsErrorSnackbarOpen={setIsErrorSnackbarOpen}
        />
    )
}

export default DataExportBusinessData
